import { render, staticRenderFns } from "./DxListTaskAgrupedActivity.vue?vue&type=template&id=70ff11b3&"
import script from "./DxListTaskAgrupedActivity.vue?vue&type=script&lang=js&"
export * from "./DxListTaskAgrupedActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports